import axios from 'axios'
import { API_URL } from 'services/config'
import Notification from 'models/Notification'
import Paginator from 'models/Paginator'

class NotificationsService {
    listNofitications = (params) =>
        axios.get(`${API_URL}/notifications`, { params }).then(({ data: { data, pagination } }) => {
            return {
                notifications: data.map((notification) => {
                    return Notification.fromJson(notification)
                }),
                paginator: Paginator.fromJson(pagination),
            }
        })

    getQuoteTypeById = (id) =>
        axios
            .get(`${API_URL}/multi-quotes/${id}`)
            .then(({ data: { data: { multiQuoteType } = {} } = {} }) => multiQuoteType)
}

export default NotificationsService
